import { useDocumentMeta } from "../../hooks/useDocumentMeta";
import { seo } from "../../data/site";
import { Hero } from "./Hero";
import { Statistics } from "./Statistics";
import { HomeTestimonials } from "./Testimonials";

export function HomePage() {
  useDocumentMeta(seo.home);
  return <><Hero /><Statistics /><HomeTestimonials /></>;
}
